import React from "react";
import { motion } from "framer-motion";

const blogPosts = [
  {
    id: 1,
    title: "AI Revolutionizing Shipping & Logistics",
    excerpt:
      "Discover how artificial intelligence is driving efficiency, predictive analytics, and smarter decision-making in logistics.",
    date: "Sept 10, 2025",
    author: "Quadrangle Insights",
    image:
      "https://cdn.pixabay.com/illustrations/ai-generated-logistics-transport-8700113_1280.png",
  },
  {
    id: 2,
    title: "15 Years of Innovation: Our Journey",
    excerpt:
      "From custom solutions to AI-powered platforms, explore how Quadrangle Solutions has empowered logistics businesses for over 15 years.",
    date: "Aug 28, 2025",
    author: "Quadrangle Team",
    image:
      "https://cdn.pixabay.com/illustrations/ai-generated-logistics-industry-8366613_1280.png",
  },
  {
    id: 3,
    title: "Smart Warehousing: The AI Advantage",
    excerpt:
      "With AI and ML, smart warehouses are enhancing inventory accuracy, optimizing space, and powering real-time logistics decisions.",
    date: "July 15, 2025",
    author: "Tech Desk",
    image:
      "https://cdn.pixabay.com/illustrations/ai-generated-warehouse-supply-chain-8467447_1280.png",
  },
];

const BlogPage = () => (
  <section className="relative bg-gradient-to-br from-white via-emerald-50 to-indigo-50 py-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      {/* Page Header */}
      <div className="text-center mb-16">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900">
          Latest <span className="text-emerald-600">News & Insights</span>
        </h1>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          Stay updated with trends, stories, and updates around shipping,
          logistics, and AI innovation.
        </p>
      </div>

      {/* Blog Grid */}
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
        {blogPosts.map((post, idx) => (
          <motion.div
            key={post.id}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: idx * 0.2 }}
            className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition overflow-hidden border border-gray-100"
          >
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <p className="text-sm text-gray-500">{post.date}</p>
              <h2 className="text-xl font-semibold text-gray-800 mt-2 hover:text-emerald-600 transition">
                {post.title}
              </h2>
              <p className="text-gray-600 mt-3">{post.excerpt}</p>
              <div className="mt-4 flex justify-between items-center">
                <span className="text-sm text-gray-500">By {post.author}</span>
                <a
                  href="#"
                  className="text-emerald-600 font-medium hover:underline"
                >
                  Read more →
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default BlogPage;
